import { render, staticRenderFns } from "./PaymentPlansTable.vue?vue&type=template&id=5e66901f&"
import script from "./PaymentPlansTable.vue?vue&type=script&lang=ts&"
export * from "./PaymentPlansTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports